import { PlannerApi } from '../planner.api';
import type { ApiResponse, PlannerComment } from '@vision/ui/interfaces';
import type {
  PlannerTaskCommentCreateArgs,
  PlannerTaskCommentDeleteArgs,
  PlannerTaskCommentsArgs,
} from './task-comments.api.types';
import { buildCreateCommentRequest, buildDeleteCommentRequest, buildGetCommentsRequest } from './task-comments.routes';

export const PlannerTaskCommentEndpoints = PlannerApi.injectEndpoints({
  endpoints: (builder) => ({
    createComment: builder.mutation<ApiResponse<PlannerComment>, PlannerTaskCommentCreateArgs>({
      query: buildCreateCommentRequest,
      invalidatesTags: (result, error, arg) => [{ type: 'Comment', id: arg.taskId }],
    }),
    deleteComment: builder.mutation<void, PlannerTaskCommentDeleteArgs>({
      query: buildDeleteCommentRequest,
      invalidatesTags: (result, error, arg) => [{ type: 'Comment', id: arg.taskId }],
    }),
    getComments: builder.query<ApiResponse<PlannerComment[]>, PlannerTaskCommentsArgs>({
      query: buildGetCommentsRequest,
      providesTags: (result, error, arg) => [{ type: 'Comment', id: arg.taskId }],
    }),
  }),
});

export const { useCreateCommentMutation, useDeleteCommentMutation, useLazyGetCommentsQuery } =
  PlannerTaskCommentEndpoints;
